export enum HeorotRouterEnum {
  PlanProgramme = 'plan-programme',
  PlanTest = 'plan-test',
  DeleteTest = 'delete-test',
  PlanNormTest = 'plan-norm-test',
  Planning = 'planning',
  PlanningAndResults = 'planning-and-results',
  Settings = 'settings',
  PaperTestResult = 'paper-test-results',
  Changelog = "Changelog"
}
